const {h, render, Component} = require('preact');

class Header extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (

      <div class="row cashback-header">
        <hr class="transaction-line"></hr>
        <div class="two columns first-section transaction-date">
          {I18n.translate("js.modules.web_2018.date")}
        </div>
        <div class="two columns zerop">
          {I18n.translate("js.modules.web_2018.status")}
        </div>
        <div class="two columns zerop">
          {I18n.translate("js.modules.web_2018.Description")}
        </div>
        <div class="two columns zerop">
          {I18n.translate("js.modules.web_2018.Card")}
        </div>
        <div class="two columns zerop">
          {I18n.translate("js.modules.web_2018.total_bill")}
        </div>
        <div class="two columns cashback-earned">
          {I18n.translate("js.modules.web_2018.cash_back_earned")}
        </div>
        <hr class="transaction-line line-padding"></hr>
      </div>

    )
  }
}

module.exports = Header
